/* ============================================================================================================================== */
/* Overview

 -- Document Ready
   -- Accordion
   -- Icon Box
   -- cmslanguages
   -- Application Stage
   -- Teaser Boxed Element
   -- USP Accordion

 */

// DOCUMENT READY:ANFANG ============================================================================================================
jQuery(document).ready(function($) {

 
  /*-- Accordion ----------------------------------------*/
  function accordion () {
    $('.accordion__heading').next().hide();

    function toggle (headings, show) {
      // Blendet den Inhalt zu einer oder meherern Überschriften abhängig von show ein und aus
      headings.toggleClass('accordion--active', show);
      headings.next().stop(true)[show ? 'slideDown' : 'slideUp'](300, function() {
        $(window).trigger('accordionChanged')
      });
      headings.children('.glyph').toggleClass('glyphicons-plus', !show).toggleClass('glyphicons-minus', show);
    }

    $('body').on('click', '.accordion__heading', function () {
      var hl = $(this);
      if (hl.hasClass('accordion--active')) {
        toggle(hl, false);
      } else {
        toggle($('.accordion__heading').not(hl), false);
        toggle(hl, true);
      }
    });
  };
  accordion ();

  /*-- Icon Box ----------------------------------------*/
  $('.iconbox').hover(function() {
      $(this).find('.iconbox__content--hover').stop(true).fadeToggle(300);
  });


  /*-- cmslanguages ----------------------------------------*/
  if (typeof cmslanguages !== 'undefined') {
      var elements = $('[data-market]');
      var market;
      $.each(elements, function (k, elem) {
          market = $(elem).data('market');

          if (typeof cmslanguages[market] !== 'undefined') {
              $(elem).attr('href', cmslanguages[market]);
          } else {
              $(elem).removeAttr('href');
          }
      });
  }  



  /*-- Teaser Boxed Element ----------------------------------------*/
  $('.teaser--boxed').hover(function() {
      $(this).find('.teaser__content--hover').stop(true).fadeToggle(300);
  });


  /*-- USP Accordion ----------------------------------------*/
  $(".usp-trigger").click(function(){

		var defaultImage = 0;
		var newImage = $(this).index();
		$(".usp__background > div").removeClass("usp__background--active");
	 	$(".usp__background > div").eq(newImage).addClass("usp__background--active");

		if ($(this).hasClass("usp__block--active")) {
			$(".usp__block").removeClass("usp__block--active");
			$(".usp__block").removeClass("usp__block--inactive");
			$(".usp__background > div").removeClass("usp__background--active");
		 	$(".usp__background > div").eq(defaultImage).addClass("usp__background--active");
		}else{
			$(".usp__block").removeClass("usp__block--active");
			$(".usp__block").addClass("usp__block--inactive");
		  $(this).closest(".usp__block").removeClass("usp__block--inactive");
			$(this).closest(".usp__block").addClass("usp__block--active");
		}
	});


});
// DOCUMENT READY:ENDE ============================================================================================================



// WEBPACK FOOTER //
// ./js/contentelements/tx-module.js